import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('COMMENT_LIKE').plugin(axiosPlugin, {template: "array"});

let createCommentLikeAction = redux.fetchActionCreate();

let deleteCommentLikeAction = redux.fetchActionDelete();

export const createCommentLike = (type, parentId, commentId) => createCommentLikeAction(`/${type}/${parentId}/comments/${commentId}/likes`);
export const deleteCommentLike = (type, parentId, commentId) => deleteCommentLikeAction(`/${type}/${parentId}/comments/${commentId}/likes`);

export const createSubCommentLike = (type, parentId, commentId, subCommentId) => createCommentLikeAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}/likes`);
export const deleteSubCommentLike = (type, parentId, commentId, subCommentId) => deleteCommentLikeAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}/likes`);

export const commentLike = redux.reducer();